import React from 'react'

import { ButtonGroup } from '../../generic/buttonGroup'
import Error from '../../generic/Error'
import RadioToggle from '../../generic/toggles/radioToggle'
import IneligibleError from '../../generic/IneligibleError'
export default ({
  transmissions,
  transmission,
  updateVehicleProp,
  isError,
  isIneligible,
  isDisabled,
  isAdmin,
  isDigitalRetail,
  vin,
  year,
  make,
  model,
  trim,
  mileage,
  kbbUrl,
  isCobrandDR,
  offerCode,
  isAssigned,
  isIneligibleVehiclesEnabled,
  isVehicleGrounded
}) => (
  <>
    <ButtonGroup>
      <RadioToggle
        id={'transmission'}
        pills={transmissions}
        testId={'vd-bt-transmissions'}
        isDisabled={isIneligible || isDisabled}
        selectedIndex={transmission && transmissions.findIndex(a => a.displayName === transmission.displayName)}
        onClickItem={index => updateVehicleProp('transmission', transmissions[index].transmissionId)}
        isError={isError}
        showIsDefault={true}
      />
    </ButtonGroup>

    {!isIneligible && <Error isError={isError} id={'transmission-error'} text={'Please select your transmission.'} />}
    {transmission && (
      <IneligibleError
        isError={transmission.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)}
        detail="transmission"
        isAdmin={isAdmin}
        kbbUrl={kbbUrl}
        isOfferCodeTcOffer={offerCode && offerCode.toUpperCase() === 'TC'}
        {...{ vin, year, make, model, trim, mileage, isDigitalRetail, isCobrandDR }}
      />
    )}
  </>
)
